import type {FC} from 'react';
import {useStores} from 'hooks/useStores';
import {ListCell} from 'modules/datagrid/components/cells';

interface ProgramCellProps {
  programs: string[];
}

export const ProgramCell: FC<ProgramCellProps> = ({programs}) => {
  const {meStore} = useStores();

  const programNames = programs
    .map((id) => meStore.myProgramsLookup[id]?.name || null)
    .filter(Boolean);

  const sortedProgramNames = programNames.sort((a, b) => a.localeCompare(b));

  return <ListCell items={sortedProgramNames} itemLabel="program" />;
};
